import ConcursoList from './list';

export default function ConcursoPage() {
  return <ConcursoList />;
}
